
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/type/sponsored",
      function () {
        return require("private-next-pages/type/sponsored.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/type/sponsored"])
      });
    }
  